import { Fade, Slide } from '@wds/motion';
import { createMemoStyles, safeRest } from '@wds/utils';
import React, { createRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import { IconX } from '@wds/icons';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles$1 = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing,
      type = _ref.type;
  return {
    wrenchCloseButton: function wrenchCloseButton(_ref2) {
      var component = _ref2.component;
      var componentSpecificStyles = {
        badge: {
          position: 'relative',
          top: 'none',
          right: 'none',
          padding: 0,
          marginLeft: spacing[3]
        },
        banner: {
          position: 'absolute',
          top: spacing[2],
          right: spacing[2],
          padding: 0
        },
        default: {
          position: 'absolute',
          right: spacing[1],
          top: spacing[1],
          padding: spacing[2]
        }
      };
      return _objectSpread(_objectSpread({}, componentSpecificStyles[component || 'default']), {}, {
        fontSize: type.fontSize.body,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '0',
        textDecoration: 'none',
        background: 'transparent',
        border: 'none',
        '&:hover': {
          transition: 'none',
          textDecoration: 'none'
        },
        '&:active': {
          transition: 'none',
          outline: 'none'
        }
      });
    }
  };
});
var useStyles$2 = useStyles$1;

var _excluded = ["children", "component", "label", "onClick", "type", "variant"];

var CloseButton = function CloseButton(_ref) {
  _ref.children;
      var component = _ref.component,
      label = _ref.label,
      onClick = _ref.onClick;
      _ref.type;
      var variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();

  var _useStyles = useStyles$2({
    theme: theme,
    component: component
  }),
      wrenchCloseButton = _useStyles.wrenchCloseButton;

  return /*#__PURE__*/React.createElement("button", Object.assign({
    onClick: onClick,
    type: "button",
    className: wrenchCloseButton,
    "aria-label": label
  }, safeRest(rest)), /*#__PURE__*/React.createElement(IconX, {
    title: "close",
    color: variant
  }));
};

CloseButton.displayName = "CloseButton";
CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light'])
};
CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light'
};
var CloseButton$1 = CloseButton;

/* eslint-disable jsx-a11y/no-static-element-interactions */

var Overlay = function Overlay(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line testing-library/consistent-data-testid
    React.createElement("div", {
      className: className,
      onClick: onClick,
      "data-testid": "wds-overlay"
    })
  );
};

Overlay.displayName = "Overlay";
Overlay.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
Overlay.defaultProps = {
  onClick: undefined
};
var Overlay$1 = Overlay;

var useStyles = createMemoStyles(function (theme) {
    var palette = theme.palette;
    var sheet = {
        width: {
            sm: '320px',
            md: '50%',
            lg: '75%',
        },
    };
    var width = {
        sm: sheet.width.sm,
        md: sheet.width.md,
        lg: sheet.width.lg,
    };
    var overlayShadow = {
        left: '6px 0 12px 0 rgba(0, 0, 0, 0.06)',
        right: '-6px 0 12px 0 rgba(0, 0, 0, 0.06)',
        bottom: '0 -6px 12px 0 rgba(0, 0, 0, 0.06)',
    };
    var sheetStyles = {
        wrenchSheetOverlayContainer: function (_a) {
            var elevation = _a.elevation;
            return ({
                position: 'relative',
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
            });
        },
        wrenchSheetOverlay: ({
            '& > div': {
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                backgroundColor: palette.background.overlay,
            },
        }),
        wrenchSheetContainer: function (_a) {
            var placement = _a.placement, elevation = _a.elevation;
            return ({
                position: 'fixed',
                top: placement !== 'bottom' ? 0 : null,
                bottom: placement === 'bottom' ? 0 : null,
                left: 0,
                right: 0,
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
            });
        },
        wrenchSheet: function (_a) {
            var placement = _a.placement;
            return ({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: placement === 'bottom' ? 0 : null,
                bottom: placement !== 'bottom' ? 0 : null,
                pointerEvents: 'none',
            });
        },
        wrenchSheetPanel: function (_a) {
            var placement = _a.placement, size = _a.size, offsetTop = _a.offsetTop, elevation = _a.elevation;
            var offsetPx = offsetTop ? "".concat(offsetTop.toString(), "px") : '0px';
            var placementStyle = {
                position: 'fixed',
                bottom: 0,
                top: placement !== 'bottom' ? offsetPx : null,
                left: placement !== 'right' ? 0 : null,
                right: placement !== 'left' ? 0 : null,
                boxShadow: placement ? overlayShadow[placement] : null,
            };
            return __assign({ backgroundColor: palette.background.light, zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space + 1, display: 'flex', flexDirection: 'column', minWidth: '320px', overflowY: 'auto', outline: 'none', pointerEvents: 'all', width: placement !== 'bottom' && size ? width[size] : null, height: placement === 'bottom' ? 'auto' : '100vh', minHeight: placement === 'bottom' ? '42px' : null }, (placement && placementStyle));
        },
    };
    return sheetStyles;
});

var Sheet = function (_a) {
    var children = _a.children, onClose = _a.onClose, _b = _a.show, show = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'sm' : _c, _d = _a.placement, placement = _d === void 0 ? 'right' : _d, _e = _a.showCloseButton, showCloseButton = _e === void 0 ? false : _e, _f = _a.closeButtonLabel, closeButtonLabel = _f === void 0 ? 'Close Modal' : _f, _g = _a.blocking, blocking = _g === void 0 ? true : _g, _h = _a.offsetTop, offsetTop = _h === void 0 ? 0 : _h, _j = _a.elevation, elevation = _j === void 0 ? undefined : _j, rest = __rest(_a, ["children", "onClose", "show", "size", "placement", "showCloseButton", "closeButtonLabel", "blocking", "offsetTop", "elevation"]);
    var sheetPanelRef = createRef();
    var classes = useStyles({
        size: size,
        placement: placement,
        blocking: blocking,
        offsetTop: offsetTop,
        elevation: elevation,
    });
    useEffect(function () {
        if (sheetPanelRef.current) {
            sheetPanelRef.current.focus();
        }
    }, [sheetPanelRef, show]);
    var getSlideDirection = function () {
        var direction = 'left';
        if (!placement || placement === 'right') {
            return direction;
        }
        return placement === 'bottom' ? 'up' : 'right';
    };
    var handleClick = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var closeButton = function () {
        return (React.createElement(CloseButton$1, { onClick: handleClick, variant: "dark", label: closeButtonLabel }));
    };
    return (React.createElement(React.Fragment, null,
        blocking && (React.createElement("div", { className: classes.wrenchSheetOverlayContainer },
            React.createElement(Fade, { in: show, speed: "fast" },
                React.createElement("div", null,
                    React.createElement("div", { className: classes.wrenchSheetOverlay },
                        React.createElement(Overlay$1, { onClick: handleClick, className: "wds-overlay" })))))),
        React.createElement("div", { className: classes.wrenchSheetContainer },
            React.createElement(Slide, { in: show, direction: getSlideDirection() },
                React.createElement("div", null,
                    React.createElement("div", __assign({ className: classes.wrenchSheet }, safeRest(rest)),
                        React.createElement("div", { role: "dialog", className: classes.wrenchSheetPanel, ref: sheetPanelRef, tabIndex: -1 },
                            showCloseButton && closeButton(),
                            children)))))));
};

var SHEET_SIZES = ['sm', 'md', 'lg'];
var SHEET_PLACEMENTS = ['left', 'right', 'bottom'];

export { SHEET_PLACEMENTS, SHEET_SIZES, Sheet };
